// Calendar utilities — pure functions, all dates treated in local timezone.

export function startOfDay(d: Date): Date {
  const x = new Date(d)
  x.setHours(0, 0, 0, 0)
  return x
}
export function endOfDay(d: Date): Date {
  const x = new Date(d)
  x.setHours(23, 59, 59, 999)
  return x
}
export function startOfWeek(d: Date): Date {
  // ISO 8601: week starts Monday
  const x = startOfDay(d)
  const day = x.getDay()
  const diff = day === 0 ? -6 : 1 - day
  x.setDate(x.getDate() + diff)
  return x
}
export function endOfWeek(d: Date): Date {
  const s = startOfWeek(d)
  s.setDate(s.getDate() + 6)
  return endOfDay(s)
}
export function startOfMonth(d: Date): Date {
  const x = startOfDay(d)
  x.setDate(1)
  return x
}
export function endOfMonth(d: Date): Date {
  const x = startOfMonth(d)
  x.setMonth(x.getMonth() + 1)
  x.setDate(0)
  return endOfDay(x)
}
export function startOfYear(d: Date): Date {
  const x = startOfDay(d)
  x.setMonth(0)
  x.setDate(1)
  return x
}
export function endOfYear(d: Date): Date {
  const x = startOfDay(d)
  x.setMonth(11)
  x.setDate(31)
  return endOfDay(x)
}
export function addDays(d: Date, n: number): Date {
  const x = new Date(d)
  x.setDate(x.getDate() + n)
  return x
}
export function addWeeks(d: Date, n: number): Date {
  return addDays(d, n * 7)
}
export function addMonths(d: Date, n: number): Date {
  const x = new Date(d)
  x.setMonth(x.getMonth() + n)
  return x
}
export function addYears(d: Date, n: number): Date {
  const x = new Date(d)
  x.setFullYear(x.getFullYear() + n)
  return x
}
export function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  )
}
export function isWeekend(d: Date): boolean {
  const day = d.getDay()
  return day === 0 || day === 6
}
export function dayKey(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}
export function dayKeyFromIso(iso: string): string {
  return dayKey(new Date(iso))
}

// ISO 8601 week number: weeks start on Monday and week 1 contains the
// year's first Thursday. Standard de_DE convention "KW XX".
export function isoWeek(d: Date): number {
  const target = new Date(d.getTime())
  const dayNr = (d.getDay() + 6) % 7 // Mon=0 .. Sun=6
  target.setHours(0, 0, 0, 0)
  target.setDate(target.getDate() - dayNr + 3)
  const firstThursday = target.getTime()
  target.setMonth(0, 1)
  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay() + 7) % 7))
  }
  return 1 + Math.round((firstThursday - target.getTime()) / 604_800_000)
}

// Stable color from string (project ID)
const PALETTE = [
  '#FF6B35',
  '#3B82F6',
  '#10B981',
  '#F59E0B',
  '#A855F7',
  '#EC4899',
  '#06B6D4',
  '#84CC16',
  '#EF4444',
  '#14B8A6',
]

export function colorForKey(key: string | null): string {
  if (!key) return '#6B6259' // tertiary for entries without project
  let hash = 0
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) | 0
  }
  return PALETTE[Math.abs(hash) % PALETTE.length]
}
